export default "__VITE_ASSET__Cn_mUFzH__"